import React from 'react';
import { Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';
import { BaasicTable, TableFilter, BaasicDropdown, DatePicker, BaasicHeader } from 'core/components';
import moment from 'moment';

const ProductActivityTemplate = ({
	t,
	actions,
	productActivityViewStore,
	productActivityViewStore: {
		loading,
		rootStore,
		listStore,
		tableData,
		noDataItem,
		data,
		product,
		form,
		format,
		columnFilterSetup,
		queryUtility,
		warehouseDropdownStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader rootStore={rootStore} title="PRODUCTACTIVITYVIEW.LABEL.TITLE" />
			<div className="order__header">
				<div className="container--fluid">
					<div className="row">
						<div className="col col-sml-12 col-med-6 col-xlrg-4 spc--bottom--sml">
							<div className="order__header__item">
								<h4 className="order__header__title type--base">{t('PRODUCTACTIVITYVIEW.LABEL.PRODUCTNAME')}</h4>
								<p>{product.name}</p>
							</div>
						</div>
						<div className="col col-sml-12 col-med-6 col-xlrg-4 spc--bottom--sml">
							<div className="order__header__item">
								<h4 className="order__header__title type--base">{t('PRODUCTACTIVITYVIEW.LABEL.SKU')}</h4>
								<p>{product.mainSku}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="order__details flex--vertical flex--grow--1">
				<div>
					<div className="row row--form">
						<div className="col col-sml-4 spc--bottom--sml">
							<DatePicker
								field={form.$('dateRangeStart')}
								maxDate={moment(form.$('dateRangeEnd').value, format).toDate()}
								rootStore={rootStore}
								isFilter={true}
								format={format}
							/>
						</div>
						<div className="col col-sml-4 spc--bottom--sml">
							<DatePicker
								field={form.$('dateRangeEnd')}
								minDate={moment(form.$('dateRangeStart').value, format).toDate()}
								rootStore={rootStore}
								isFilter={true}
								format={format}
							/>
						</div>
						<div className="col col-sml-4 spc--bottom--sml">
							<BaasicDropdown label="PRODUCTACTIVITYVIEW.LABEL.WAREHOUSE" dropdownStore={warehouseDropdownStore} />
						</div>
					</div>
				</div>

				<div className="spc--bottom--med">
					<button className="btn btn--med btn--primary" type="submit" onClick={e => form.onSubmit(e)}>
						{t('APPLY')}
					</button>
				</div>

				{data.length != 0 && (
					<div className="flex--grow--1">
						<BaasicTable
							{...{
								listStore,
								queryUtility,
								data,
								tableData: tableData,
								viewStore: productActivityViewStore,
								noDataItem,
								actions,
							}}
						/>
					</div>
				)}
				<TableFilter viewStore={productActivityViewStore} columnFilterSetup={columnFilterSetup} />
				<ReactTooltip />
			</div>
		</section>
	);
};

export default defaultTemplate(ProductActivityTemplate);
